import { useEffect } from 'react';
import { useOktaAuth } from './service';
import { useNavigate } from 'react-router-dom';
import { AppCircularProgress } from '../../components/AppCircularProgress';
import { useLazyVerifyTokenQuery } from '../../services/auth';
import { showAlert } from '../../reduxActions/alert';
import { useAppDispatch } from '../../storeHook';

export const LoginCallBack: React.FC = () => {
  const { getAccessToken } = useOktaAuth();
  const [verifyToken] = useLazyVerifyTokenQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    getAccessToken().then((res) => {
      if (res) {
        verifyToken({
          token: res,
        })
          .unwrap()
          .catch((err) => {
            dispatch(
              showAlert({
                content: err.data.error,
                severity: 'error',
              })
            );
          });
      } else {
        // const isOkta = JSON.parse(
        //   localStorage.getItem('isOktaUser') as string
        // );
        // if (isOkta) {
        navigate('/admin-sign-in');
        // } else {
        //   navigate('/sign-in');
        // }
      }
    });
  }, []);

  return <AppCircularProgress />;
};
